import React from "react";
import "./support.css";

export const Support: React.FC = () => {
    return (
        <div className="support-root">
            <h1>Here &amp; Now Support</h1>
            <br />
            <p>
                Thank you for using Here &amp; Now. Our goal is to provide a simple, reliable way
                for residents to stay informed, find local resources, and participate in
                community decisions. If you have questions, need help, or want to report
                an issue, we're here to assist.
            </p>

            <hr className="support-separator" />

            <h2>Frequently Asked Questions</h2>

            <p>
                <strong>What is Here &amp; Now?</strong>
                <br />
                Here &amp; Now Now is a mobile app platform that provides real-time news and events
                including cultural and recreational activities and resources, and information about community service providers.
            </p>

            <p>
                <strong>What devices are supported?</strong>
                <br />
                Here &amp; Now is available for iOS and Android smartphones and supports the
                most recent OS versions.
            </p>

            <p>
                <strong>Why does the app request my location?</strong>
                <br />
                Location access allows the app to provide information relevant to your
                city and enable location-based services. You can disable location at any
                time in your device settings.
            </p>

            <p>
                <strong>How do I report a problem?</strong>
                <br />
                You can contact us directly using the email below.
            </p>

            <p>
                <strong>Can I delete my account?</strong>
                <br />
                Absolutely. When you delete your account, all data along with the account will be permanently deleted. If you would like to proceed, log into the app using your username and password, select manage account on the navigation menu, go to profile tab, and select delete account. You will be prompted to confirm that you want to delete your account. If you choose to proceed, please note this action is irreversible. 
                Click <a href="/deleteaccount" target="" rel="noopener noreferrer">here</a> if you would like to request your account to be deleted.
            </p>

            <hr className="support-separator" />

            <h2>Contact Support</h2>

            <p>If you need help or have feedback, please contact us:</p>

            <p>
                <strong>Email:</strong> herenow@vinformatix.com
                <br />
                <strong>Response Time:</strong> Within 1-2 business days
            </p>
        </div>
    );
};
